import React from 'react';
import Breadcrumb from '../Breadcrumb';
import cn from 'classnames';

const HeaderCommon = ({
  title,
  children,
  isBorderBottom = true,
  className,
}) => {
  return (
    <div
      className={cn('px-20 pb-16 d-table w-100p', className, {
        'border-bottom-placeholder': isBorderBottom,
      })}
    >
      <div className="fz-20 fw-600 d-table-cell va-m word-break pr-10">
        <span>{title}</span>
      </div>
      {children}

      <br style={{ clear: 'both' }} />
    </div>
  );
};

export default HeaderCommon;
